// extracted by mini-css-extract-plugin
export default {"marker":"colorMarker_marker__lHijj"};